<script setup>
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

    const discordUrl = import.meta.env.VITE_DISCORD_URL
    const trelloUrl = import.meta.env.VITE_TRELLO_URL
</script>

<template>
    <div class="bg-gray-900 py-24 sm:py-8">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="mx-auto max-w-2xl lg:max-w-none">
                <h2 class="text-lg font-semibold leading-8 text-white">Connect with us on Discord or checkout our roadmap on Trello</h2>
                <p class="mt-1 text-base leading-7 text-gray-300">We are interested in your ideas, feedback, and suggestions.</p>
                <div class="flex items-center mx-auto ml-6 mt-10 grid items-start gap-x-14 gap-y-10 lg:mx-0 grid-cols-10">
                    <div>
                        <a :href="discordUrl" aria-label="Join us on Discord" class="col-span-2 lg:col-span-1 flex items-center justify-center">
                            <FontAwesomeIcon :icon="['fa-brands', 'fa-discord']" size="2x" color="white" aria-hidden="true"/>
                        </a>
                    </div>
                    <div>
                        <a :href="trelloUrl" aria-label="View our roadmap on Trello" class="col-span-2 lg:col-span-1 flex items-center justify-center">
                            <FontAwesomeIcon :icon="['fa-brands', 'fa-trello']" size="2x" color="white" aria-hidden="true"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
